// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Delivery20 from './Delivery20';
import Delivery20Filled from './Delivery20Filled';
import Delivery20CircleFilled from './Delivery20CircleFilled';
import Delivery24 from './Delivery24';
import Delivery24Filled from './Delivery24Filled';
import Delivery24CircleFilled from './Delivery24CircleFilled';
import Delivery40 from './Delivery40';
import Delivery40Filled from './Delivery40Filled';
import Delivery48 from './Delivery48';
import Delivery48Filled from './Delivery48Filled';

type DeliveryProps = {
    variation:
        | '20'
        | '20Filled'
        | '20CircleFilled'
        | '24'
        | '24Filled'
        | '24CircleFilled'
        | '40'
        | '40Filled'
        | '48'
        | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Delivery20,
    Delivery20Filled,
    Delivery20CircleFilled,
    Delivery24,
    Delivery24Filled,
    Delivery24CircleFilled,
    Delivery40,
    Delivery40Filled,
    Delivery48,
    Delivery48Filled,
};

const Delivery: FC<DeliveryProps> = ({ variation, ...props }) => {
    const variationKey = `Delivery${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Delivery" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Delivery;
